import * as React from "react";
import { Typography } from "antd";

export default function TermsOfUse() {
  return (
    <div className="bg-white max-w-screen-xl mx-auto m-4 p-8">
      <p>
        This page outlines the terms and conditions under which you may access
        CarePulse, which is owned and managed by Evalucom Consulting Ltd.
      </p>
      <p>
        In these Terms of Use, Evalucom Consulting Ltd are referred to as
        “Evalucom Consulting” or “we” or “us”. Please read these Terms of Use
        (“Terms”) carefully.
      </p>

      <Typography.Title level={3}>1. Who may use CarePulse</Typography.Title>
      <p>
        You may only use CarePulse if you accept the Terms and the Privacy
        Notice, and agree to abide by them.
      </p>
      <p>
        CarePulse is intended for professional use by commissioners and
        providers of care services only, to share information with one another
        and the NHS London Purchased Healthcare Team. In using CarePulse, you
        represent and warrant that you are authorised to accept these Terms and
        use CarePulse on behalf of your company, organisation, or other legal
        entity.
      </p>

      <Typography.Title level={3}>2. Privacy</Typography.Title>
      <p>
        In using CarePulse, you understand and consent to the collection and use
        of your personal data in accordance with our Privacy Notice.
      </p>

      <Typography.Title level={3}>3. Your obligations</Typography.Title>
      <div>In using CarePulse you must</div>
      <ul>
        <li>
          Use CarePulse strictly for the specific purpose of assisting
          commissioners and providers of care services in commissioning
          placements and improving quality of care;
        </li>
        <li>
          Use the website only for lawful purposes, in a manner that does not
          infringe upon the rights of third parties;
        </li>
        <li>
          Maintain the confidentiality of any confidential or commercially
          sensitive information that may be accessed on CarePulse and not share
          that information with any unauthorised person(s);
        </li>
        <li>
          At all times have the authority from your company, organisation or
          other legal entity to access and use CarePulse;
        </li>
        <li>
          Cease using CarePulse immediately if at any time your authority to
          access CarePulse is revoked or otherwise removed by your company,
          organisation or other legal entity;
        </li>
        <li>
          Ensure that all information you provide on CarePulse is to the best of
          your knowledge accurate and up-to-date;
        </li>
        <li>
          Bear the sole responsibility of taking the necessary steps to check
          for the accuracy and completeness of information found on CarePulse
          before relying upon it;
        </li>
        <li>
          Not modify, reproduce, publicly display, perform, distribute or use
          for any public or commercial purposes the materials on the site
          without the explicit written permission from the appropriate content
          or material provider.
        </li>
        <li>
          Ensure that all information provided that relates to Service Users is
          anonymised and does not allow Service Users to be personally
          identified.
        </li>
      </ul>

      <Typography.Title level={3}>
        4. Disclaimers and Limitation of Liability
      </Typography.Title>
      <div>
        In your use of CarePulse, we make no warranty or guarantee as to
      </div>
      <ul>
        <li>Whether CarePulse will meet your requirements;</li>
        <li>
          The provision of CarePulse on an uninterrupted, secure, or error-free
          basis;
        </li>
        <li>
          The accuracy, completeness, availability, timeliness, or reliability
          of any information on CarePulse that has been supplied by its users.
        </li>
      </ul>
      <div>
        As a result, we will not bear any risk, responsibility or liability for
        any loss or damage that arises as a consequence of
      </div>
      <ul>
        <li>
          Any harm to your computer system, loss of data, or other harm that
          results from accessing or using CarePulse;
        </li>
        <li>
          The deletion of, or the failure to store or to transmit, any data that
          is contained on CarePulse;
        </li>
        <li>
          Reliance on any information found on CarePulse that has been supplied
          by its users;
        </li>
        <li>Any unauthorised use of CarePulse;</li>
        <li>
          The content and materials that may be found on any third-party links.
        </li>
      </ul>

      <Typography.Title level={3}>5. Intellectual property</Typography.Title>
      <p>
        CarePulse is the sole property of and a registered trademark of Evalucom
        Consulting. Using CarePulse does not give you ownership of any
        intellectual property rights in CarePulse, Evalucom Consulting, or the
        content that you access.
      </p>
      <p>
        We are obligated to protect our reputation and trademarks and we reserve
        the right to request removal of any link to our website. Evalucom
        Consulting and the Evalucom Consulting logo are registered trademarks of
        Evalucom Consulting Ltd.
      </p>
      <p>
        Use of these marks requires our express permission and a license
        agreement. We reserve the right to take legal action against
        unauthorised use of these or any other of our portfolio of trademarks.
      </p>

      <Typography.Title level={3}>6. Termination of account</Typography.Title>
      <p>
        If you no longer wish to have a registered account, you may terminate
        your account at any time through CarePulse or by emailing the NHS London
        Purchased Healthcare Team. If you no longer accept these terms and
        conditions, or any future revision to these terms and conditions, you
        must cease using CarePulse. Continued use of CarePulse indicates your
        continued acceptance of these terms of conditions.
      </p>
      <p>
        If, for any reason, we believe that you have not complied with the terms
        and conditions contained herein, we may, at our sole discretion, cancel
        your access to CarePulse immediately and without prior notice.
      </p>

      <Typography.Title level={3}>7. General</Typography.Title>
      <p>
        We may revise these Terms from time to time. We will notify you of any
        changes to the Terms by emailing you at your registered email address.
        By continuing to access or use CarePulse after the revisions to these
        Terms become effective, you agree to be bound by the revised Terms.
      </p>
      <p>
        If any of these terms are determined to be illegal, invalid or otherwise
        unenforceable then they shall be severed and the remaining terms shall
        remain in full force and effect.
      </p>
      <p>
        These terms shall be governed by and interpreted in accordance with the
        laws of England and Wales.
      </p>
      <p>
        Any disputes arising out of these terms and conditions shall be subject
        to the exclusive jurisdiction of the courts of England and Wales.
      </p>
      <p>
        These Terms represent an agreement between you and Evalucom Consulting
        Ltd. If you have any questions about these Terms, please contact us at
        info@evalucom.co.uk.
      </p>
    </div>
  );
}
